import { render, staticRenderFns } from "./prise-en-charge-assurance-proprietaire.vue?vue&type=template&id=cb0960be&scoped=true"
import script from "./prise-en-charge-assurance-proprietaire.vue?vue&type=script&lang=ts"
export * from "./prise-en-charge-assurance-proprietaire.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0960be",
  null
  
)

export default component.exports